var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAds = function SvgAds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "2 2 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.855 17.82c.69-.4 1.21-1.31 1.2-2.11V8.14c0-.8-.61-1.69-1.3-2.09l-6.512-3.73c-.68-.39-1.75-.39-2.43 0L4.28 6.04C3.581 6.44 3.01 7.2 3 8l-.019 7.72c0 .79.52 1.72 1.21 2.11l6.632 3.85c.33.19.76.3 1.21.3s.89-.11 1.22-.3zM4.89 16.61l6.632 3.85c.26.15.76.15 1.02 0l6.602-3.86c.229-.133.45-.49.5-.78a1 1 0 0 0 .01-.11h-.01l.01-7.57c0-.31-.34-.73-.6-.88l-6.512-3.73c-.12-.07-.32-.11-.52-.11s-.4.04-.52.11L4.97 7.25c-.26.15-.59.6-.59.9v7.57c0 .3.25.74.51.89",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05 10.45h1.9L13.3 8.4v7.2l-3.35-2.05h-1.9c-.5 0-.9-.4-.9-.9v-1.3c0-.5.4-.9.9-.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.55h1.05v2.2c0 .28-.22.5-.5.5H11c-.28 0-.5-.22-.5-.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 9.65 1.4-1M14.7 12h1.65M14.5 14.35l1.4 1"
  }))));
};
export default SvgAds;